import React from "react";
import {useMutation, useSubscription} from "@apollo/client";
import {QUERY_USERS} from "../registryComponentsGQL.js";
import {Box} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {DELETE_USER} from "./UserGQL.js";
import {Button as ButtonMui} from "@mui/material";
import LayerUserPackage from "./LayerUserPackage.js";
import LayerWallet from "./Wallet.js";
import LayerEntrances from "./LayerEntrances.js";
import LayerServicesUsed from "./LayerServicesUsed.js";

function Personale(props){

    const [deleteUser]=useMutation(DELETE_USER);
    const [showAddLayer,setShowAddLayer] = React.useState(null);
    const [showPortfolio,setShowPortfolio] = React.useState(null);
    const [showEntrances,setShowEntrances] = React.useState(null);
    const [showServicesUsed,setShowServicesUsed] = React.useState(null);

    function onEscLayer(){
        setShowAddLayer(null);
        setShowPortfolio(null);
        setShowEntrances(null);
        setShowServicesUsed(null);
    }


    const { data, loading } = useSubscription(
      QUERY_USERS,
    );

     const columnsDip = [
    { field: 'name', headerName: 'Nome', width: 170 },
    { field: 'surname', headerName: 'Cognome', width: 170 },
    { field: 'fiscal_code', headerName: 'Codice Fiscale', width: 170 },
         { field: 'golf_card_number', headerName: 'Numero tessera', width: 170 },
    {
    field: 'Modifica',
    headerName: 'Modifica',
    width: 120,
    renderCell: (cellValues) => {
      return (
        <ButtonMui
          variant="contained"
         color="warning"
          onClick={(event) => {
            props?.setElementSel(cellValues.row)
          }}
        >
          Modifica
        </ButtonMui>
      );},
   },
   {
    field: 'Stato abbonamento',
    headerName: 'Stato abbonamento',
    width: 200,
    renderCell: (cellValues) => {
      return (
        <ButtonMui
          variant="contained"
          color="success"
          onClick={(event) => {
            setShowAddLayer(cellValues.row.id);
          }}
        >
          Stato abbonamento
        </ButtonMui>
      );},
   },
         {
             field: 'Mostra portafoglio',
             headerName: 'Mostra portafoglio',
             width: 200,
             renderCell: (cellValues) => {
                 return (
                     <ButtonMui
                         variant="contained"
                         color="success"
                         onClick={(event) => {
                             setShowPortfolio(cellValues?.row?.wallet_id);
                         }}
                     >
                         Mostra portafoglio
                     </ButtonMui>
                 );},
         },
         {
             field: 'Mostra ingressi',
             headerName: 'Mostra Ingressi',
             width: 200,
             renderCell: (cellValues) => {
                 return (
                     <ButtonMui
                         variant="contained"
                         color="success"
                         onClick={(event) => {
                             console.log("CELLVALUES",cellValues?.row?.id);
                             setShowEntrances(cellValues?.row?.id);
                         }}
                     >
                         Mostra Ingressi
                     </ButtonMui>
                 );},
         },
         {
             field: 'Mostra Servizi Utilizzati',
             headerName: 'Mostra Servizi Utilizzati',
             width: 250,
             renderCell: (cellValues) => {
                 return (
                     <ButtonMui
                         variant="contained"
                         color="success"
                         onClick={(event) => {
                             console.log("CELLVALUES",cellValues?.row?.id);
                             setShowServicesUsed(cellValues?.row?.id);
                         }}
                     >
                         Mostra Servizi Utilizzati
                     </ButtonMui>
                 );},
         },
         {
             field: 'Cancella',
             headerName: 'Cancella',
             width: 120,
             renderCell: (cellValues) => {
                 return (
                     <ButtonMui
                         variant="contained"
                         color="error"
                         onClick={(event) => {
                             let res=window.confirm("Sei sicuro di voler eliminare l'utente?");
                             if(res){
                                 deleteUser({variables:{ id:cellValues.row.id}})
                             }
                         }}
                     >
                         Cancella
                     </ButtonMui>
                 );},
         },
  ];


    return (
      <Box overflow="auto"  height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}}>
        <div style={{ height: '75vh', width: '100%' }}>
          <DataGrid
            rows={data && data["clubmate_usersregister_userregister"] || []}
            columns={columnsDip}
          />
        </div>
          {
              showAddLayer && <LayerUserPackage onEscLayer={onEscLayer} id={showAddLayer} />
          }
          {
              showPortfolio && <LayerWallet onEscLayer={onEscLayer} id={showPortfolio}/>
          }
          {
              showEntrances && <LayerEntrances onEscLayer={onEscLayer} id={showEntrances} />
          }
          {
              showServicesUsed && <LayerServicesUsed onEscLayer={onEscLayer} id={showServicesUsed} />
          }
      </Box>
    )
}

export default Personale;